import {
  Autocomplete, Box, Button, Checkbox, FormControlLabel, Grid, InputAdornment, Paper, TextField, Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Tooltip
} from '@mui/material'
import { Component } from 'react';
import { withTranslation } from 'react-i18next'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTime } from 'luxon';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { BasicPatientDetails, BillSuccessPoPUp } from '../../../../Components/Common Components/CommonComponents';
import './IPAppointments.css';
// import Barcode from 'react-barcode';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import Loader from '../../../../Components/Loader';
import { Colors } from '../../../../Styles/Colors';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { AmountFormat, checkTransationMandatory } from '../../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol, TXN_MSG_MAX, TXN_MSG_MAX_LEN } from '../../../../Utility/Constants';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
const BarCodePrintCount = [];
for (let i = 1; i <= 30; i++) { BarCodePrintCount.push(i) }

class IPBilling extends Component {

  constructor(props) {
    super(props)
    this.state = {
      PayableAmount: "",
      PayMadeBy: "",
      isCash: false,
      isCard: false,
      isUPI: false,
      isCheque: false,
      isBankTranfer: false,
      PaymentDate: new Date(),
      CashAmount: "",
      CardAmount: "",
      CardTransactionNumber: "",
      UPINumber: "",
      UPIAmount: "",
      BankTfrAmount: "",
      BankTfrNumber: "",
      ChequeNumber: "",
      ChequeAmount: "",
      BarCodePrintCounts: 1,
      AdmissionDetails: this.props.AdmissionDetails,
      corporatePay: "",
      employerID: this.props.PatientDetails.employer_id,
      InsuranceName: null,
      PolicyNumber: "",
      InsuranceList: [],
      NewInsurance: false,
      reservationDetails: [],
      bill_receipt_id:null,
      patientId:null,
      isCredit:false,
      successText:'',
      resetRow: 1,
      row: 1,
      resetColumn: 1,
      column: 1,
      previewUrl: "",
    }
  }

  componentDidMount = () => {
    this.getInsuranceList()
    this.getReservePayment()
    this.getLabelLayoutDetails()
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message,
      DisableBtn: false
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message,
      // DisableBtn: false
    })
  }

  lodaerFunction = (key) => {
    this.setState({
      isLoader: key
    }, () => {
      setTimeout(() => {
        this.setState({
          isLoader: false
        })
      }, 2000);
    })
  }

  getReservePayment = () => {
    try {
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
      RestAPIService.getAll(`${Serviceurls.IP_RESERVATION_PAYMENT}?reservation_id=${this.state.AdmissionDetails?.reservation_id ? this.state.AdmissionDetails?.reservation_id : ""}&clinic_id=${UserData.clinic_id ? UserData.clinic_id : null}`)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              reservationDetails: response.data.data ? response.data.data : [],
            })
          }
        })
        .catch(error => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message);
          } else {
            this.errorMessage(error?.message)
          }
        });
    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  getLabelLayoutDetails = () => {
    try {
      RestAPIService.getAllTwo(Serviceurls.IP_LABEL_LAYOUT_CONFIG)
        .then((response) => {
          if (response.data.status === "success") {
            const { label_count = {} } = response.data.data || {};
            const { rows = 1, columns = 1 } = label_count;
            this.setState({
              resetRow: rows,
              row: rows,
              resetColumn: columns,
              column: columns,
            }, () => this.printIpLabel(true))
          }
        }).catch((error) => {
          this.errorMessage(error.response.data.message || error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  BarcodePrint() {
    try {
      RestAPIService.PrintPDF(Serviceurls.IP_BARCODE_PRINT + "?ip_admission_id=" + this.state.AdmissionDetails?.ip_admission_id).
        then((response) => {
          this.setState({ DisablePrnt: false })
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
          }
        }).catch((error) => {
          this.setState({ DisablePrnt: false })
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (e) {
      console.log(e.message)
    }
  }

  printIpLabel = (isFromPreview = false) => {
    try {
      if (!this.state.row || !this.state.column) {
        this.errorMessage("Row and column are required");
        this.setState({ DisablePrnt: false })
        return;
      }
      RestAPIService.getAll(`${Serviceurls.IP_LABEL_PRINT}?ip_admission_id=${this.state.AdmissionDetails?.ip_admission_id}&row=${this.state.row}&column=${this.state.column}`)
        .then((response) => {
          this.setState({ DisablePrnt: false })
          if (response) {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            if (isFromPreview) {
              this.setState({ previewUrl: fileURL })
            } else {
              window.open(fileURL);
            }
          }
        }).catch((error) => {
          this.setState({ DisablePrnt: false })
          this.errorMessage(error.response?.data?.message);
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.setState({ DisablePrnt: false })
    }
  }

  getInsuranceList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              InsuranceList: response.data.data,
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  renderTextField = (label, stateKey) => {
    return (
      <TextField
        size='small'
        sx={{ width: "10vw" }}
        autoComplete='off'
        label={label}
        value={this.state[stateKey]}
        onChange={(e) => {
          const { value } = e.target;
          const isValid = CommonValidation.numberOnly(value);
          if ((isValid && +value <= 24 && +value > 0) || value === "") {
            this.setState({ [stateKey]: e.target.value }, () => {
              if(value){
                this.printIpLabel(true);
              }
            })
          }
        }}
      />
    )
  }

  renderComponentRight() {
    const { t } = this.props
    let BarCodeValue = `${this.state.AdmissionDetails?.ip_number}`
    let data = {
      patient_name: this.state.AdmissionDetails?.patient_name,
      patient_gender: "Male",
      text: this.state.AdmissionDetails?.ip_number,
      photo_url: this.state.AdmissionDetails?.photo_url
    }

    return (
      <Paper className='eMed_IPappoint_right'>
        <Typography className='eMed_IPappoint_title'>{t("PatientDetails")}</Typography>
        <Box component={'div'} className='eMed_IPappoint_Patient_Details'><BasicPatientDetails data={data} /></Box>
        <Box component={'div'} className="eMed_IP_BarCode_Box">
          <Typography className='eMed_IP_barcode_title'>{t("InPatientlabel")}</Typography>
          <Box className='eMed_IP_barcode_img'> 
            {/* <Barcode value={BarCodeValue} width={1.3} /> */}
            {this.state.previewUrl ? 
            <iframe title="IPLabelPreview" src={this.state.previewUrl} width="100%" height="100%"></iframe> 
            : <Typography sx={{ fontSize: "0.8vw", textAlign: "center", padding: "1vw" }}>{t("Preview Not Available")}</Typography>}
          </Box>
        </Box>
        <Box component={'div'}>
          {/* <Autocomplete
            size='small'
            options={BarCodePrintCount}
            getOptionLabel={(option) => option}
            value={this.state.BarCodePrintCounts}
            onChange={(event, newValue) => {
              this.setState({
                BarCodePrintCounts: newValue
              })
            }}
            renderInput={(params) => (
              <TextField
                sx={{ width: '8vw' }}
                {...params}
                label={t("NoofPrint")}
                placeholder={t("NoofPrint")}
              />
            )}
          /> */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '1vw', alignItems: 'center', margin: '0.625vw' }}>
            {this.renderTextField("Row(s)", "row")}
            <Typography sx={{ fontWeight: "600", fontSize: "1vw" }}>X</Typography>
            {this.renderTextField("Column(s)", "column")}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1vw' }}>
            <Button emed_tid={'Reset_Button'} disabled={this.state?.isIpLoader} variant='outlined' size="small" id="eMed_Config_btn"
              onClick={() => { this.setState((prevState) => ({ row: prevState.resetRow || 1, column: prevState.resetColumn || 1 })) }}>
              <RestartAltIcon />
            </Button>
            <Button size='small' disabled={this.state.DisablePrnt} variant='contained' color='primary'
              onClick={() => { this.setState({ DisablePrnt: true }, () => { this.printIpLabel() }) }}>
              <LocalPrintshopIcon />
            </Button>
          </Box>
        </Box>
        {/* <FormControlLabel className="eMed_IP_BarCode_PrintBox" control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.RememberPrintCount} onChange={(e) => { this.setState({ RememberPrintCount: e.target.checked }) }} size='small' />} label={t("RememberPrintCount")} /> */}
      </Paper>
    )
  }
  renderTextBox(label, value, Key, maxLength, width, multiline, disable) {
    let states = this.state;
    return (
      <TextField
        disabled={disable}
        inputProps={{ maxLength: maxLength }}
        sx={{ width: width, marginLeft: '2vw' }}
        size='small'
        label={label}
        value={value}
        onChange={(e) => {
          if (Key === "PayableAmount") {
            let number = CommonValidation.NumberWithDot(e.target.value);
            if ((number && +e.target.value > 0) || e.target.value === "") {
              states[Key] = e.target.value
              if (e.target.value === "") {
                this.setState({
                  isCash: false,
                  isCard: false,
                  isUPI: false,
                  isCheque: false,
                  isBankTranfer: false,
                  CashAmount: "",
                  CardAmount: "",
                  CardTransactionNumber: "",
                  UPINumber: "",
                  UPIAmount: "",
                  BankTfrAmount: "",
                  BankTfrNumber: "",
                  ChequeNumber: "",
                  ChequeAmount: "",
                })
              }
            }
          }
          else {
            states[Key] = e.target.value
          }

          this.setState({ states })
        }}
        multiline={multiline}
        rows={4}
      />
    )
  }

  renderAmountTextFields = (label, key, Icon) => {
    var states = this.state
    let { t } = this.props;
    return (
      <TextField
        sx={{ padding: 0, margin: 0 }}
        className='eMed_CrdPop_Amount_TextFields'
        size='small'
        label={t(label)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img src={Icon} alt={label} className='eMed_action_img_small' />
            </InputAdornment>
          ),
        }}
        value={states[key]}
        onChange={(e) => {
          let number = CommonValidation.NumberWithDot(e.target.value);
          if (number || e.target.value === "") {
            states[key] = e.target.value
            this.setState({
              states
            })
          }
        }}
      />
    )
  }

  renderNumberTextFields = (label, key, Right = false) => {
    var states = this.state
    let { t } = this.props;
    return (
      <TextField
        className='eMed_CrdPop_Amount_TextFields'
        sx={{ marginLeft: Right ? "1vw" : 0 }}
        inputProps={{ maxLength: 20 }}
        size='small'
        label={t(label)}
        value={states[key]}
        onChange={(e) => {
          let number = CommonValidation.gstnumberValidation(e.target.value);
          if (number || e.target.value === "") {
            states[key] = e.target.value.toUpperCase()
            this.setState({
              states
            })
          }
        }}
      />
    )
  }

  handleCheckBox = (e, key) => {
    var states = this.state
    states[key] = e.target.checked
    this.setState({ states }, () => {
      if (!states.isCash) { this.setState({ CashAmount: "" }) }
      if (!states.isCard) { this.setState({ CardAmount: "", CardTransactionNumber: "" }) }
      if (!states.isUPI) { this.setState({ UPIAmount: "", UPINumber: "" }) }
      if (!states.isCheque) { this.setState({ ChequeAmount: "", ChequeNumber: "" }) }
      if (!states.isBankTranfer) { this.setState({ BankTfrAmount: "", BankTfrNumber: "" }) }
      if (states.isCash && !states.isCard && !states.isUPI && !states.isBankTranfer) {
        this.setState({ CashAmount: this.state.PayableAmount, })  // Fetch Full amount in Cash Amount, when only the cash is selected
      }
    })
  }

  CalculateAmount() {
    try {
      var states = this.state
      let CashAmt = states.CashAmount === "" ? 0 : +states.CashAmount;
      let CardAmt = states.CardAmount === "" ? 0 : +states.CardAmount;
      let UPIAmt = states.UPIAmount === "" ? 0 : +states.UPIAmount;
      let bankTransferAmt = states.BankTfrAmount === "" ? 0 : +states.BankTfrAmount;
      let ChequeAmt = states.ChequeAmount === "" ? 0 : +states.ChequeAmount;
      if (states.PayableAmount === "") {
        return false
      }
      else if (+states.PayableAmount === (CashAmt + CardAmt + UPIAmt + bankTransferAmt + ChequeAmt)) {
        return true
      }
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  // postNewInsurance = () => {
  //   var states = this.state

  //   var data = {
  //     "insurance_name": states.insurance_company_name
  //   }

  //   RestAPIService.create(data, Serviceurls.FO_INSURANCE_LIST)
  //     .then((response) => {
  //       if (response.data.status === 'success') {
  //       }
  //     }).catch((e) => {
  //       if (e?.response?.data?.message) {
  //         this.errorMessage(e.response.data.message)
  //       } else {
  //         this.errorMessage(e.message)
  //       }
  //     })
  // }

  receivePayment() {
    try {
      let states = this.state;
      let Paymethod = [];
      if (states.CashAmount !== "") { Paymethod.push(1) }
      if (states.CardAmount !== "") { Paymethod.push(2) }
      if (states.UPIAmount !== "") { Paymethod.push(3) }
      if (states.BankTfrAmount !== "") { Paymethod.push(5) }
      if (states.ChequeAmount !== "") { Paymethod.push(4) }

      if (states.PayableAmount !== "" &&
        states.PayableAmount !== 0 &&
        ((states.corporatePay == "Insurance" && states.InsuranceName !== "" && states.PolicyNumber !== "") || (states.corporatePay == "Corporate" || states.corporatePay == "")) &&
        this.CalculateAmount() &&
        DateTime.fromJSDate(states.PaymentDate).toFormat('yyyy-MM-dd') !== "Invalid DateTime" &&
        ((states.isCash || states.isCard || states.isBankTranfer || states.isUPI || states.isCheque))) {

        if (checkTransationMandatory() && ((this.state.CardAmount !== "" && this.state.CardTransactionNumber === "") ||
          (this.state.UPIAmount !== "" && this.state.UPINumber === "") ||
          (this.state.ChequeAmount !== "" && this.state.ChequeNumber === "") ||
          (this.state.BankTfrAmount !== "" && this.state.BankTfrNumber === ""))) {
          this.errorMessage("Please,Enter Reference Number")
        } else if (
          (this.state.CardTransactionNumber !== "" && this.state.CardTransactionNumber?.length < TXN_MSG_MAX_LEN) || 
          (this.state.UPINumber !== "" && this.state.UPINumber?.length < TXN_MSG_MAX_LEN) || 
          (this.state.ChequeNumber !== "" && this.state.ChequeNumber?.length < TXN_MSG_MAX_LEN) || 
          (this.state.BankTfrNumber !== "" && this.state.BankTfrNumber?.length < TXN_MSG_MAX_LEN)
        ) {
          this.errorMessage(TXN_MSG_MAX)
        } else {
          if (localGetItem('isNewBilling') === "true") {
            let data = {
              "patient_id": this.state.AdmissionDetails?.patient_id,
              "ip_admission_id": this.state.AdmissionDetails?.ip_admission_id,
              "advance_amount": +states.PayableAmount,
              "is_refund": false,
              "refund_amount": 0,
              "cash_amount": +states.CashAmount,
              "card_amount": +states.CardAmount,
              "upi_amount": +states.UPIAmount,
              "bank_amount": +states.BankTfrAmount,
              "cheque_amount": +states.ChequeAmount,
              "payment_mode": Paymethod,
              "card_ref_no": states.CardTransactionNumber,
              "upi_ref_no": states.UPINumber,
              "bank_ref_no": states.BankTfrNumber,
              "cheque_ref_no": states.ChequeNumber,
            }

            RestAPIService.create(data, Serviceurls.CASH_COUNTER_ADVANCE_POST)
              .then((response) => {
                if (response.data.status === "success") {
                  if ((states.InsuranceName != "" && states.InsuranceName != null) && states.NewInsurance) {
                    this.postNewInsurance()
                    this.lodaerFunction(false)
                  }
                  // this.successMessage(response.data.message)
                  this.setState({
                    bill_receipt_id: response.data?.data?.receipt_id,
                    isCredit: false,
                    patientId: null,
                    successText: response.data.message
                  })
                  // this.navigatePage()
                } else {
                  this.lodaerFunction(false)
                  this.errorMessage(response.data.message)
                }
              }).catch(error => {
                this.lodaerFunction(false)
                if (error?.response?.data?.status === "fail") {
                  this.errorMessage(error.response.data.message)
                } else {
                  this.errorMessage(error.message)
                }
              })

          } else {
            this.lodaerFunction(true)
            var data = {
              "patient_id": this.state.AdmissionDetails?.patient_id,
              "ip_admission_id": this.state.AdmissionDetails?.ip_admission_id,
              "patient_account_number": this.state.AdmissionDetails?.patient_account_number,
              "payable_amount": +states.PayableAmount,
              "cash_amount": +states.CashAmount,
              "card_amount": +states.CardAmount,
              "upi_amount": +states.UPIAmount,
              "bank_transfer_amount": +states.BankTfrAmount,
              "cheque_amount": +states.ChequeAmount,
              "payment_date": DateTime.fromJSDate(states.PaymentDate).toFormat('yyyy-MM-dd'),
              "payment_made_by": CommonValidation.removeSpace(states.PayMadeBy),
              "payment_mode": Paymethod,
              "card_ref_no": states.CardTransactionNumber,
              "upi_ref_no": states.UPINumber,
              "bank_ref_no": states.BankTfrNumber,
              "cheque_ref_no": states.ChequeNumber,
              "employer_id": states.employerID ? states.employerID : "",
              "primary_payment_type": states.corporatePay === "Insurance" ? "Insurance credit" : states.corporatePay === "Corporate" ? "Corprate credit" : JSON.parse(localGetItem('allow_patient_credit_bills')) ? "Patient credit" : '',
              "insurance_company_name": states?.InsuranceName ? states?.InsuranceName : null,
              "policy_number": states?.PolicyNumber ? states?.PolicyNumber : null
            }
            if (this.props.isFromOT) {
              let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
              data["clinic_id"] = UserData?.clinic_id ? UserData?.clinic_id : null
            }
            RestAPIService.create(data, Serviceurls.IP_ADVANCE_PAYMENT).
              then((response) => {
                if (response.data.status === "success") {
                  if ((states.InsuranceName != "" && states.InsuranceName != null) && states.NewInsurance) {
                    this.postNewInsurance()
                    this.lodaerFunction(false)
                  }
                  this.successMessage(response.data.message)
                  this.navigatePage()
                } else {
                  this.lodaerFunction(false)
                  this.errorMessage(response.data.message)
                }
              }).catch(error => {
                this.lodaerFunction(false)
                if (error?.response?.data?.status === "fail") {
                  this.errorMessage(error.response.data.message)
                } else {
                  this.errorMessage(error.message)
                }
              })
          }
        }
      } else {
        this.setState({
          DisableBtn: false
        }, () => {
          if (states.PayableAmount === "" || states.PayableAmount === 0) {
            this.errorMessage("Please Enter the Payable Amount")
          } else if (DateTime.fromJSDate(states.PaymentDate).toFormat('yyyy-MM-dd') === "Invalid DateTime") {
            this.errorMessage("Invalid Payment Date. Please Select the Correct Date")
          } else if (!(states.isCash || states.isCard || states.isBankTranfer || states.isUPI || states.isCheque)) {
            this.errorMessage("Please Select any Payment Methods")
          } else if (!this.CalculateAmount()) {
            this.errorMessage("Amount Not Matched ")
          } else if (states.corporatePay == "Insurance" && (states.InsuranceName == "" || states.PolicyNumber == "")) {
            this.errorMessage("Insurance details should be Mandatory ")
          }
        })

      }
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }


  renderComponentLeft() {
    const { t } = this.props
    let states = this.state
    var corporate = {}
    var Insurance = {}
    if (this.props?.PatientDetails?.company_name || this.props?.PatientDetails?.insurance_company_name) {
      corporate["company_name"] = this.props?.PatientDetails?.company_name
      corporate["id_no"] = this.props?.PatientDetails?.id_no
      corporate["discount_percent"] = this.props?.PatientDetails?.discount_percent
      Insurance["insurance_company_name"] = this.props?.PatientDetails?.insurance_company_name
      Insurance["policy_number"] = this.props?.PatientDetails?.policy_number
    } else {
      corporate = this.props.PatientDetails?.primary_payment?.corporate_detail ? this.props.PatientDetails?.primary_payment.corporate_detail : "-"
      Insurance = this.props.PatientDetails?.primary_payment?.insurance_detail ? this.props.PatientDetails?.primary_payment.insurance_detail : "-"
    }
    return (
      <Paper className='eMed_IPappoint_left'>
        <Box>
          {/* <Typography className='eMed_IPappoint_title'>{t("PatientInsCov")}</Typography> */}
          <Box component={'div'} className='eMed_cor_txt'>
            {/* Commented and Moved To Admission Details */}
            {/* <FormControl>
              <RadioGroup value={this.state.corporatePay}
                onClick={(e) => {
                  if (e.target.value === this.state.corporatePay) {
                    this.setState({
                      corporatePay: "",
                      totalDiscountedPercentage: "",
                      totalDiscountedAmount: ""
                    })
                  } else {
                    if (e.target.value === "Corporate") {
                      let CorporateName = this.props.PatientDetails?.primary_payment?.corporate_detail?.company_name || this.props?.PatientDetails?.company_name;
                      if (CorporateName !== "" && CorporateName !== null && CorporateName !== undefined) {
                        this.setState({
                          corporatePay: e.target.value,
                          totalDiscountedPercentage: corporate?.discount_percent ? corporate?.discount_percent : "-"
                        })
                      }
                      else {
                        this.errorMessage("Patient is not Mapped with Any Corporate. Please Map the Corporate in Registration Page")
                      }
                    } else if (e.target.value === "Insurance") {
                      let newInsuranceKey = this.props.PatientDetails?.insurance_company_name ? this.props.PatientDetails?.insurance_company_name : '-'
                      let InsuranceName = this.props.PatientDetails?.primary_payment?.insurance_detail?.insurance_company_name ? this.props.PatientDetails?.primary_payment.insurance_detail?.insurance_company_name : newInsuranceKey
                      if (InsuranceName !== "" && InsuranceName !== null && InsuranceName !== undefined && InsuranceName !== "-") {
                        this.setState({
                          corporatePay: e.target.value,
                          InsuranceName: InsuranceName,
                          PolicyNumber: this.props.PatientDetails?.primary_payment?.insurance_detail?.policy_number ? this.props.PatientDetails?.primary_payment?.insurance_detail?.policy_number : this.props.PatientDetails?.policy_number ? this.props.PatientDetails?.policy_number : '-'
                        })
                      } else {
                        this.errorMessage("Patient is not Registered with Any Insurance. Please Register the Insurance in Registration Page")
                      }
                    } else {
                      this.setState({
                        corporatePay: e.target.value,
                        totalDiscountedPercentage: corporate?.discount_percent ? corporate?.discount_percent : "-"
                      })
                    }
                  }
                }}
              >
                <FormControlLabel value={"Corporate"} control={<Radio size="small" />} label={<Typography id="eMed_recPayment_radioCorpTxt">
                  <span id="eMed_recPayment_radioCorpTxt" style={{ fontWeight: 600 }}>{`${t("Corporate")}: `}</span>{`${t("PatientUnder")} `}
                  <span className='eMed_cor_font'>
                    {corporate?.company_name ? corporate?.company_name : "-"}
                  </span>  {`${t("CorporatePlan")} (${t("ID.No.")}`}
                  <span className='eMed_cor_font'>{corporate?.id_no ? corporate?.id_no : "-"}</span> {") "}
                  <span className='eMed_cor_font'>
                    {corporate?.discount_percent ? corporate?.discount_percent : "0"}
                    %</span>
                  {` ${t("corporateTxt")}`}</Typography>} />
                <FormControlLabel value={"Insurance"} control={<Radio size="small" />} label={<Typography id="eMed_recPayment_radioCorpTxt">
                  <span id="eMed_recPayment_radioCorpTxt" style={{ fontWeight: 600 }}>{`${t("Insurance")}: `}</span>{`${t("PatientRegisteredUnder")} `}
                  <span className='eMed_cor_font'>{Insurance?.insurance_company_name ? Insurance?.insurance_company_name : "-"}</span>
                  {`${t(" RegNo")}`} <span className='eMed_cor_font'>{Insurance?.policy_number ? Insurance?.policy_number : "-"}</span>
                </Typography>} />
              </RadioGroup>
            </FormControl> */}
            {Insurance?.insurance_company_name == "" && Insurance?.policy_number == "" && this.state.corporatePay == "Insurance" ?
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "1.8vw" }}>
                <Autocomplete
                  sx={{ width: "15vw" }}
                  size="small"
                  options={states.InsuranceList}
                  getOptionLabel={(option) => (typeof (option) === "string" ? option : option.insurance_name)}
                  onChange={(event, value) => {
                    states["InsuranceName"] = value?.insurance_name ? value?.insurance_name : ""
                    states["NewInsurance"] = false
                    this.setState({
                      states
                    })
                  }}
                  clearIcon={false}
                  value={states.InsuranceName}
                  renderInput={(params) => (
                    <TextField
                      label={t("Insurance Company Name") + " *"} InputProps={{ ...params.InputProps }}
                      // onChange={(event) => {
                      //   states["InsuranceName"] = event.target.value
                      //   states["NewInsurance"] = true
                      //   this.setState({
                      //     states
                      //   })
                      // }}
                      {...params}
                    />
                  )}
                />
                <TextField
                  label={t("Policy Number *")}
                  size="small"
                  sx={{ width: "15vw", marginLeft: "0.5vw" }}
                  value={this.state.PolicyNumber}
                  onChange={(e) => {
                    let number = CommonValidation.numberOnly(e.target.value);
                    if ((number) || e.target.value === "") {
                      this.setState({ PolicyNumber: e.target.value })
                    }
                  }}
                />
              </div> : null}
          </Box>
        </Box>
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
          <Typography className='eMed_IPappoint_title' sx={{ backgroundColor: Colors.white }}>{t("PaymentDetails")}</Typography>
          <Box className="eMed_CrdPop_Check_Group">
            <FormControlLabel sx={{ width: '16vw' }} control={<Checkbox checked={true} size='small' />} label={t("Receive As Advance")} />
          </Box>
        </Box>

        <Box component={'div'} display={'flex'} flexDirection={"row"} marginTop={"1vw"} >
          {this.renderTextBox(`${t("PayableAmount")}`, this.state.PayableAmount, "PayableAmount", 50, "20vw", false, false)}
          <LocalizationProvider dateAdapter={AdapterDayjs} >
            <DatePicker
              inputFormat='DD-MM-YYYY'
              label={t("PaymentDate")}
              value={this.state.PaymentDate}
              name="PaymentDate"
              minDate={new Date()}
              maxDate={new Date()}
              disabled
              onChange={(newDate) => {
                if (newDate === null) {
                  this.setState({ PaymentDate: new Date() })
                }
                else if (newDate > new Date()) {
                  this.setState({ PaymentDate: new Date() })
                }
                else {
                  this.setState({ PaymentDate: newDate?.$d })
                }
              }}
              renderInput={(params) => <TextField style={{ width: '20vw', marginLeft: '2vw' }} size='small' {...params} />}
            />
          </LocalizationProvider>
        </Box>
        <Box component={'div'} display={'flex'} flexDirection={"row"} marginTop={"1vw"} marginBottom={"1vw"}>
          {this.renderTextBox(`${t("PaymentMadeBy")}`, this.state.PayMadeBy, "PayMadeBy", 100, "42vw", false, false)}
        </Box>
        <Typography className='eMed_IPappoint_title'>{t("PaymentMethods")}</Typography>
        <Box display={'flex'} flexDirection={"row"} sx={{ marginBottom: '1vw' }} >
          <Box flex={0.6} display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={"flex-start"} paddingLeft={"2vw"}>
            <Box className="eMed_CrdPop_Check_Group">
              <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' disabled={(this.state.PayableAmount === "" || this.state.PayableAmount == 0)} control={<Checkbox checked={this.state.isCash} onChange={(e) => { this.handleCheckBox(e, "isCash") }} size='small' />} label={t("Cash")} />
              <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' disabled={(this.state.PayableAmount === "" || this.state.PayableAmount == 0)} control={<Checkbox checked={this.state.isCard} onChange={(e) => { this.handleCheckBox(e, "isCard") }} size='small' />} label={t("Card")} />
              <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' disabled={(this.state.PayableAmount === "" || this.state.PayableAmount == 0)} control={<Checkbox checked={this.state.isUPI} onChange={(e) => { this.handleCheckBox(e, "isUPI") }} size='small' />} label={t("UPI")} />
              <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' disabled={(this.state.PayableAmount === "" || this.state.PayableAmount == 0)} sx={{ width: "10vw" }} control={<Checkbox checked={this.state.isBankTranfer} onChange={(e) => { this.handleCheckBox(e, "isBankTranfer") }} size='small' />} label={t("BankTransfer")} />
              <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' disabled={(this.state.PayableAmount === "" || this.state.PayableAmount == 0)} control={<Checkbox checked={this.state.isCheque} onChange={(e) => { this.handleCheckBox(e, "isCheque") }} size='small' />} label={t("Cheque")} />
            </Box>
            <Box component={'div'}>
              {
                this.state.isCash ? this.renderAmountTextFields("CashAmount", "CashAmount", ImagePaths.CashIcon.default) : null
              }
              {
                this.state.isCard ?
                  <Box component={"div"} display={"flex"} flexDirection={"row"}>
                    {this.renderAmountTextFields("CardAmount", "CardAmount", ImagePaths.CardIcon.default)}
                    {this.renderNumberTextFields("CardTransactionNumber", "CardTransactionNumber", true)}
                  </Box>
                  : null
              }
              {
                this.state.isUPI ?
                  <Box component={"div"} display={"flex"} flexDirection={"row"}>
                    {this.renderAmountTextFields("UPIAmount", "UPIAmount", ImagePaths.UPIIcon.default)}
                    {this.renderNumberTextFields("UPITransactionNumber", "UPINumber", true)}
                  </Box>
                  : null
              }
              {
                this.state.isBankTranfer ?
                  <Box component={"div"} display={"flex"} flexDirection={"row"}>
                    {this.renderAmountTextFields("BankTransferAmount", "BankTfrAmount", ImagePaths.BankTransferIcon.default)}
                    {this.renderNumberTextFields("BankTransactionNumber", "BankTfrNumber", true)}
                  </Box>
                  : null
              }
              {
                this.state.isCheque ?
                  <Box component={"div"} display={"flex"} flexDirection={"row"}>
                    {this.renderAmountTextFields("ChequeAmount", "ChequeAmount", ImagePaths.ChequeIcon.default)}
                    {this.renderNumberTextFields("ChequeTransactionNumber", "ChequeNumber", true)}
                  </Box>
                  : null
              }
            </Box>
          </Box>
          {/* <Box position={'fixed'} flex={0.4} display={'flex'} alignItems={'flex-end'} justifyContent={"flex-end"} right={"35vw"} top={"82%"}>
            <Button size='small' id="eMed_invd_Button" variant='contained' onClick={() => { this.receivePayment("") }}>{t("ReceivePayment")}</Button>
          </Box> */}
        </Box>
        {this.state.reservationDetails?.length > 0 ?
          <Box>
            <Typography className='eMed_IPappoint_title'>{t("Reservation Advance Receipt Details")}</Typography>
            <Box display={'flex'} flexDirection={"row"} height={'auto'} p={"0.5vw"} width={'40vw'}>
              <TableContainer sx={{ height: "100%", overflow: 'auto' }}>
                <Table aria-label="simple table" stickyHeader>
                  <TableHead sx={{ backgroundColor: Colors.Background, height: '5vh' }}>

                    <TableCell sx={{ flex: 0.18 }} className='eMed_Credit_bill_pop_Tbl_Header' align="center">Receipt No</TableCell>
                    <TableCell sx={{ flex: 0.18 }} className='eMed_Credit_bill_pop_Tbl_Header' align="center">Receipt Date & Time</TableCell>
                    <TableCell sx={{ flex: 0.18 }} className='eMed_Credit_bill_pop_Tbl_Header' align="center">Receipt Type</TableCell>
                    <TableCell sx={{ flex: 0.18 }} className='eMed_Credit_bill_pop_Tbl_Header' align="right">{t('Total Amount') + `(${CurrencySymbol})`}</TableCell>
                  </TableHead>
                  <TableBody>{
                    this.state.reservationDetails?.length > 0 && this.state.reservationDetails?.map((row) => (
                      <TableRow>
                        <TableCell sx={{ flex: 0.18 }} className='eMed_Credit_bill_pop_Tbl_Body' align="center">
                          <Typography fontSize={'0.9vw'} fontWeight={600}>{row?.receipt_number ?
                            row?.receipt_number?.length > 18 ?
                              <Tooltip placement='top' title={row?.receipt_number}><div style={{ fontSize: '0.9vw', fontWeight: 600 }}>{'...' + row?.receipt_number?.slice(4)}</div></Tooltip> :
                              row?.receipt_number : '-'}</Typography>
                        </TableCell>
                        <TableCell sx={{ flex: 0.18 }} className='eMed_Credit_bill_pop_Tbl_Body' align="center"><Typography>{row?.invoice_date ? row?.invoice_date : '-'}</Typography></TableCell>
                        <TableCell sx={{ flex: 0.18 }} className='eMed_Credit_bill_pop_Tbl_Body' align="center"><Typography>{row?.receipt_for ? row?.receipt_for : '-'}</Typography></TableCell>
                        <TableCell sx={{ flex: 0.18, fontWeight: 600 }} className='eMed_Credit_bill_pop_Tbl_Body' align="right">
                          {row?.amount_received ? AmountFormat(row?.amount_received)?.replace(`${CurrencySymbol}`, "") : 0}
                        </TableCell>
                      </TableRow>
                    ))
                  }
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
          : null}
      </Paper>
    )
  }

  ClearData() {
    this.setState({
      PayableAmount: "",
      PayMadeBy: "",
      isCash: false,
      isCard: false,
      isUPI: false,
      isCheque: false,
      isBankTranfer: false,
      PaymentDate: new Date(),
      CashAmount: "",
      CardAmount: "",
      CardTransactionNumber: "",
      UPINumber: "",
      UPIAmount: "",
      BankTfrAmount: "",
      BankTfrNumber: "",
      ChequeNumber: "",
      ChequeAmount: "",
    })
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  CreditTypePost() {
    try {
      this.lodaerFunction(true)
      let data = {
        "patient_id": this.state.AdmissionDetails?.patient_id,
        "module_id": this.state.AdmissionDetails?.ip_admission_id,
        "module_type": "In Patient",
        "credit_type": this.state.corporatePay === "Insurance" ? "Insurance credit" : this.state.corporatePay === "Corporate" ? "Corprate credit" : JSON.parse(localGetItem('allow_patient_credit_bills')) ? "Patient credit" : '',
      }
      RestAPIService.create(data, localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_CHANGE_CREDIT_PAYMENT : Serviceurls.CREDIT_TYPE_CHANGE).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({ DisableBtn: false })
            this.successMessage("IP Admission Created Succesfully")
            this.lodaerFunction(false)
            this.navigatePage()
          }
          else {
            this.lodaerFunction(false)
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.lodaerFunction(false)
          if (error?.response?.data?.status) {
            this.errorMessage(error.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  navigatePage = () => {
    setTimeout(() => {
      if (this.props.isFromOT || this.props.PatientDetails?.fromOTModule) {
        this.props.history.push("/OTHome")
        this.setState({ DisableBtn: false })
      } else if (this.props.PatientDetails?.fromOTHome) {
        this.props.history.push("/IPHome/OThome")
        this.setState({ DisableBtn: false })
      } else {
        this.props.history.push({ pathname: "/IPHome" })
        this.setState({ DisableBtn: false })
      }
    }, 1500)
  }

  ClosePopUp = () => {
    try {
      this.setState({
        bill_receipt_id: null,
        patientId: null,
        isCredit: false,
        successText: ''
      }, () => {
        this.navigatePage()
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  render() {
    try {
      let { t } = this.props
      return (
        <Box component={"div"} className='eMed_Ipappoint_container'>
          <Grid container spacing={1} className='eMed_IPappoint_content' >
            <Grid item xs={8} sx={{ padding: 0 }}>
              {this.renderComponentLeft()}
            </Grid>
            <Grid item xs={4}>
              {this.renderComponentRight()}
            </Grid>
            <Grid item xs={12}>
              <Box className='eMed_Ipappoint_btn_div'>
                <Button id="eMed_invd_Button" size='small' variant='outlined' onClick={() => { this.props.BactToAdmissionDetials(this.state.AdmissionDetails) }}>{t("Back")}</Button>
                <Button id="eMed_invd_Button" size='small' variant='outlined' onClick={() => { this.ClearData() }}>{t("Clear")}</Button>
                <Button id="eMed_invd_Button" emed_tid="Billing_Complete_Btn" size='small' sx={{ width: "10vw" }} variant='contained' disabled={this.state.isLoader || this.state.DisableBtn} onClick={() => {
                  this.setState({
                    DisableBtn: true
                  }, () => {
                    if ((this.state.PayableAmount === "" || this.state.PayableAmount == 0)) {
                      if (this.state.corporatePay === "") {
                        this.successMessage("IP Admission Created Succesfully")
                        this.navigatePage()
                      } else {
                        this.CreditTypePost()
                      }
                    } else {
                        this.receivePayment("")
                    }
                  })
                }}>{(this.state.PayableAmount === "" || this.state.PayableAmount == 0) ? t("Complete") : "Receive & Complete"}</Button>
              </Box>
            </Grid>
          </Grid>
          {this.state.isErrorMsg ?
            <ToastMsg
              severity={'error'}
              msg={this.state.isErrorMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.successMsg ?
            <ToastMsg
              severity={'success'}
              msg={this.state.successMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          <Loader loaderOpen={this.state.isLoader} />
          {this.state.bill_receipt_id !== null ? <BillSuccessPoPUp isDirectPrint={true} CloseBtnText={'Close'} isCredit={this.state.isCredit} moduleType={"IP"} creditreceipt={this.state.bill_receipt_id} patientID={this.state.patiendId} ClosePopUp={this.ClosePopUp} successTxt={this.state.successText} /> : null}
        </Box>
      )
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
}
export default withTranslation()(IPBilling)

